// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// ShareModal container imports
const actions = require('client-v2/common/containers/share-modal/actions')
const shareModalSelectors = require('client-v2/common/containers/share-modal/selectors')
const socialMediums = require('client-v2/common/containers/share-modal/mediums')
// Sibling imports
const shareModalV2Selectors = require('./selectors')

function mapStateToProps(state) {
  if (!shareModalV2Selectors.isVisible(state)) {
    return { isVisible: false }
  }
  return {
    isVisible: true,
    isSocialButtonsVisible: shareModalV2Selectors.isSocialButtonsVisible(state),
    friends: shareModalSelectors.friends(state),
    friendsState: shareModalSelectors.friendsState(state),
    model: shareModalSelectors.model(state),
    socialMediums
  }
}

const mapDispatchToProps = {
  onCopy: actions.copy,
  onDismiss: actions.hide,
  onShare: actions.share
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
